// Libraries
import { useSnackbar } from "notistack";
import { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";

// Core
import { ResourceTextApplication } from "../../../core/resources";

// Feature
import { ADialog, ADialogActions, ADialogButtonsProp, ADialogContent, ADialogTitle } from "../../../common/dialog";
import { Typography } from "@mui/material";
import Grid from '@mui/material/Grid';

export interface PdfDialogProps {
    pdfUrl: string;
    onClose: (confirmed: boolean) => void;
    contractNumber?: string|undefined;
    title?:string|undefined;
    readonly?: boolean|undefined;
}

export default function PdfDialog(props: PdfDialogProps) {
    const { t } = useTranslation<ResourceTextApplication[]>(['AnelmaContract', 'AnelmaGeneral']);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    useEffect(() => {
        setIsLoading(true);

        setIsLoading(false);
    }, []);

    const actionFooterButtons: ADialogButtonsProp = {
        left: [
            {
                onClick: () => props.onClose(false),
                type: 'cancel',
                label: t('AnelmaContract:1030')
            },
        ],
        right: [
            {
                onClick: () => props.onClose(true),
                type: 'ok',
                disabled: isLoading,
                label: t('AnelmaContract:1031')
            },
        ],
    };

    const readonlyFooterButtons: ADialogButtonsProp = {
        left: [
            {
                onClick: () => props.onClose(false),
                type: 'cancel',
                label: t('AnelmaGeneral:1067')
            },
        ],
        right: []
    };

    const footerButtons: ADialogButtonsProp = props.readonly
        ? readonlyFooterButtons
        : actionFooterButtons;

    const actionTitle = t('AnelmaContract:1002');
   
    const readonlyTitle = props.title + ' ' + (props.contractNumber ?? '');
    const title = props.readonly
        ? readonlyTitle
        : actionTitle;

    return (
        <ADialog open onClose={() => props.onClose(false)}>
            <ADialogTitle>{title}</ADialogTitle>

            <ADialogContent isLoading={isLoading} size='lg'>

                {!props.readonly && (
                    <Grid style={{ paddingLeft: '24px', paddingBottom: '16px' }}>
                        <Typography variant='h5'>{t('AnelmaContract:1029')}</Typography>
                    </Grid>
                )}
                <div>
                    <iframe
                        id={'pdf-iframe'}
                        src={props.pdfUrl}
                        width="100%"
                        height="600px"
                        style={{ border: 'none' }}
                    ></iframe>
                </div>
            </ADialogContent>

            <ADialogActions buttons={footerButtons} isLoading={isLoading} />
        </ADialog>
    );
}